import { DuplicateRecoveryInformationComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/DuplicateRecoveryInformationComponent";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function DuplicateRecoveryInformationContainer () {
    const titleName = "ข้อมูลการขอกู้ซ้ำของสถานประกอบการ"; //ใส่ชื่อtitle ตรงนี้

    return(
        <div className="page-container bg-landing">
            <NavbarBorrowSystem/>
            <HeadTitle title={titleName}/>
            <DuplicateRecoveryInformationComponent/>
            <Footer />
        </div>

    )
}




